import type {
  StaffRosterOverrideCreate,
  StaffRosterOverrideUpdate,
} from "@/types/staff/api-types/staff-roster-override-types";
import type { StaffRosterOverrideFormValues } from "@/zod-schemas/staff/staff-roster-override-schema";

export const toStaffRosterOverrideCreate = (
  value: StaffRosterOverrideFormValues,
  staffId: number,
  overrideDate: string
): StaffRosterOverrideCreate => ({
  staff_id: staffId,
  override_date: overrideDate,
  is_working: value.is_working,
  start_time: value.start_time,
  end_time: value.end_time,
});

export const toStaffRosterOverrideUpdate = (
  value: StaffRosterOverrideFormValues
): StaffRosterOverrideUpdate => ({
  is_working: value.is_working,
  start_time: value.start_time,
  end_time: value.end_time,
});
